import { StringIndexedObject } from "@kanda-libs/ks-component-ts";

export const URLS: StringIndexedObject<string> = {
  HOME: "/",
  LOGIN: "/login",
  JOBS: "/jobs",
  JOB: "/job/{id}",
  LOANS: "/loans",
  COMPANY: "/company/{id}",
  COMPLETED_SETUP: "/completed-setup",
  PAYMENT: "/payment/{id}",
  PAYMENTS: "/payments",
};

export const APP_ENV = process.env.REACT_APP_ENV || "qa";
